import { FunctionalComponent, h } from '@stencil/core';
import { IIconProps } from './interfaces';

const RoundThreeQuarterStar: FunctionalComponent<IIconProps> = ({ width = '12', height = '12' }) => (
  /*@ts-ignore*/
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 12 12" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.39347 10.3C6.14632 10.1739 5.85368 10.1739 5.60653 10.3L3.20135 11.5273C2.56477 11.8521 1.83103 11.3093 1.95539 10.6055L2.40198 8.07834C2.45263 7.79173 2.35587 7.49886 2.14444 7.29883L0.271702 5.52707C-0.255087 5.02868 0.0276776 4.14227 0.745757 4.041L3.38002 3.66948C3.6598 3.63002 3.90272 3.45651 4.03079 3.20465L5.22834 0.849534C5.54924 0.218449 6.45077 0.21845 6.77167 0.849535L7.96921 3.20465C8.09728 3.45651 8.3402 3.63002 8.61998 3.66948L11.2542 4.041C11.9723 4.14227 12.2551 5.02868 11.7283 5.52707L9.85556 7.29883C9.64414 7.49886 9.54737 7.79173 9.59802 8.07834L10.0446 10.6055C10.169 11.3093 9.43523 11.8521 8.79865 11.5273L6.39347 10.3Z"
      fill="#CCCCCC"
    />
    {/*@ts-ignore*/}
    <mask id="mask0_1221_5788" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="9" height="12">
      <rect y="0.375" width="9" height="11.25" fill="#C4C4C4" />
    </mask>
    {/*@ts-ignore*/}
    <g mask="url(#mask0_1221_5788)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.3865 10.2905C6.14372 10.1666 5.85628 10.1666 5.6135 10.2905L3.18524 11.5302C2.55994 11.8494 1.83919 11.316 1.96135 10.6243L2.41257 8.06966C2.46232 7.78799 2.36728 7.50016 2.1596 7.30359L0.266888 5.51205C-0.250568 5.02226 0.0271877 4.15113 0.732546 4.0516L3.39359 3.67612C3.66841 3.63734 3.90703 3.46682 4.03283 3.2193L5.24201 0.840156C5.55722 0.219949 6.44278 0.219948 6.75799 0.840155L7.96717 3.2193C8.09297 3.46682 8.33159 3.63734 8.60641 3.67612L11.2675 4.0516C11.9728 4.15113 12.2506 5.02226 11.7331 5.51205L9.8404 7.30359C9.63272 7.50016 9.53768 7.78799 9.58743 8.06966L10.0386 10.6243C10.1608 11.316 9.44006 11.8494 8.81476 11.5302L6.3865 10.2905Z"
        fill="#FFD644"
      />
    </g>
  </svg>
);

export default RoundThreeQuarterStar;
